export { default } from './AboutCardPrimaryBenefit';
